class CianCdCheckbox extends HTMLElement {

    static get observedAttributes() {
        return ['selected'];
    }

    constructor() {
        super();
        const template = document.createElement('template')
        template.innerHTML =  `<div style="user-select: none; display: flex; align-items: center; cursor: pointer">
            <svg id="un-checked" style="display: block; margin-right: 4px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2.5" y="2.5" width="19" height="19" rx="1.5" fill="white" stroke="#E9F1F9"/>
                <path style="visibility: hidden" d="M10.2643 16.5834C10.0368 16.5834 9.81847 16.4901 9.66097 16.3243L5.98014 12.4643C5.66264 12.1318 5.67514 11.6034 6.00847 11.2868C6.34097 10.9693 6.86847 10.9809 7.18597 11.3143L10.2643 14.5418L16.8135 7.6751C17.131 7.34176 17.6593 7.32926 17.991 7.64676C18.3243 7.96426 18.3376 8.49176 18.0193 8.82426L10.8676 16.3243C10.7101 16.4901 10.4918 16.5834 10.2643 16.5834Z" fill="#0057B6"/>
             </svg>
             <svg id="checked" style="display: none; margin-right: 4px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2.5" y="2.5" width="19" height="19" rx="1.5" fill="white" stroke="#D7DEE9"/>
                <rect x="2" y="2" width="20" height="20" rx="2" fill="#508BE2" style="fill: var(--main-color)"/>
                <path d="M10.2643 16.5835C10.0368 16.5835 9.81847 16.4902 9.66097 16.3244L5.98014 12.4644C5.66264 12.1319 5.67514 11.6036 6.00847 11.2869C6.34097 10.9694 6.86847 10.9811 7.18597 11.3144L10.2643 14.5419L16.8135 7.67522C17.131 7.34188 17.6593 7.32938 17.991 7.64688C18.3243 7.96438 18.3376 8.49188 18.0193 8.82438L10.8676 16.3244C10.7101 16.4902 10.4918 16.5835 10.2643 16.5835Z" fill="white"/>
            </svg>
             <div id="cian-cd-checkbox-title" style="display: block; color: #262c40 !important;"></div>
        </div>`;
        this.attachShadow({mode: "open"})
        this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    attributeChangedCallback(name, oldValue, newValue) {
        console.log(newValue)
        if (oldValue !== newValue)
            if (newValue === 'true') {
                this.shadowRoot.querySelector('#un-checked').style.display = 'none';
                this.shadowRoot.querySelector('#checked').style.display = 'block';
            } else if (newValue === 'false') {
                this.shadowRoot.querySelector('#un-checked').style.display = 'block';
                this.shadowRoot.querySelector('#checked').style.display = 'none';
            }
    }

    connectedCallback() {
        const checkboxName = this.getAttribute('name') || 'unnamed';
        const checkBoxTitle = this.shadowRoot.querySelector('#cian-cd-checkbox-title');
        checkBoxTitle.innerHTML = this.getAttribute('title') || '';
        this.addEventListener('click', () => {
            let selected = this.getAttribute('selected') === "true";
            this.setAttribute('selected', !selected);
            let customEvent = new CustomEvent(`change-${checkboxName}`, {bubbles: true});
            customEvent.value = !selected;
            this.dispatchEvent(customEvent);
        });

    }
};

if (!customElements.get('cian-cd-checkbox')) customElements.define('cian-cd-checkbox', CianCdCheckbox);
